webpackJsonp([8],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _path2 = __webpack_require__(184);

var _path3 = _interopRequireDefault(_path2);

var _importCss2 = __webpack_require__(186);

var _importCss3 = _interopRequireDefault(_importCss2);

var _universalImport2 = __webpack_require__(187);

var _universalImport3 = _interopRequireDefault(_universalImport2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactUniversalComponent = __webpack_require__(67);

var _reactUniversalComponent2 = _interopRequireDefault(_reactUniversalComponent);

var _reactStatic = __webpack_require__(52);

var _p_two = __webpack_require__(971);

var _p_two2 = _interopRequireDefault(_p_two);

var _check = __webpack_require__(785);

var _check2 = _interopRequireDefault(_check);

var _etapes = __webpack_require__(786);

var _etapes2 = _interopRequireDefault(_etapes);

var _reactLocalizeRedux = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceWrapper = (0, _reactUniversalComponent2.default)((0, _universalImport3.default)({
  id: "./wrapper.js",
  file: "/opt/build/repo/src/containers/Services/b.js",
  load: function load() {
    return Promise.all([__webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 534)), (0, _importCss3.default)("wrapper", {
      disableWarnings: true
    })]).then(function (proms) {
      return proms[0];
    });
  },
  path: function path() {
    return _path3.default.join(__dirname, "./wrapper.js");
  },
  resolve: function resolve() {
    return /*require.resolve*/(534);
  },
  chunkName: function chunkName() {
    return "wrapper";
  }
}), {
  loading: function loading() {
    return null;
  }
});
ServiceWrapper.preload();

exports.default = function () {
  return _react2.default.createElement(
    ServiceWrapper,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement(
        "title",
        null,
        "Investiv Group | Non Sevices - Diagnostic Phytosanitaire par drone"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "xs-12 content" },
      _react2.default.createElement(
        "div",
        { className: "xs-10 xs-off-1 sm-8 sm-off-2" },
        _react2.default.createElement(
          "h3",
          null,
          _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.heading" })
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.paragraph_one" })
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.paragraph_two" })
        ),
        _react2.default.createElement(
          "div",
          { className: "xs-12 t-c" },
          _react2.default.createElement("img", { src: _p_two2.default, className: "fit" })
        ),
        _react2.default.createElement(
          "h3",
          null,
          "   ",
          _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.objectives" }),
          " "
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.objectivesText" }),
          "  "
        ),
        _react2.default.createElement(
          "ul",
          { id: "objectives" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("img", { src: _check2.default }),
            _react2.default.createElement(
              "span",
              null,
              " ",
              _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.objectiveOne" })
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("img", { src: _check2.default }),
            _react2.default.createElement(
              "span",
              null,
              " ",
              _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.objectiveTwo" })
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("img", { src: _check2.default }),
            _react2.default.createElement(
              "span",
              null,
              " ",
              _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.objectiveThree" })
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("img", { src: _check2.default }),
            _react2.default.createElement(
              "span",
              null,
              " ",
              _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.objectiveFour" })
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("img", { src: _check2.default }),
            _react2.default.createElement(
              "span",
              null,
              " ",
              _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.objectiveFive" })
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("img", { src: _check2.default }),
            _react2.default.createElement(
              "span",
              null,
              " ",
              _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.objectiveSix" })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "xs-12 top" },
          _react2.default.createElement(
            "h3",
            null,
            " ",
            _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.methodology" }),
            " "
          ),
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.methodologyText_one" })
          ),
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.methodologyText_two" })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "xs-12 top" },
          _react2.default.createElement(
            "h3",
            null,
            " ",
            _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.step" }),
            " "
          ),
          _react2.default.createElement(
            "ul",
            { id: "etapes" },
            _react2.default.createElement("span", { id: "line" }),
            _react2.default.createElement(
              "li",
              { className: "xs-12" },
              _react2.default.createElement(
                "div",
                { className: "xs-2 sm-1" },
                _react2.default.createElement("img", { src: _etapes2.default })
              ),
              _react2.default.createElement(
                "div",
                { className: "xs-10 sm-11" },
                _react2.default.createElement(
                  "span",
                  null,
                  " ",
                  _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.step_one" }),
                  " "
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: "xs-12" },
              _react2.default.createElement(
                "div",
                { className: "xs-2 sm-1" },
                _react2.default.createElement("img", { src: _etapes2.default })
              ),
              _react2.default.createElement(
                "div",
                { className: "xs-10 sm-11" },
                _react2.default.createElement(
                  "span",
                  null,
                  " ",
                  _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.step_two" }),
                  " "
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: "xs-12" },
              _react2.default.createElement(
                "div",
                { className: "xs-2 sm-1" },
                _react2.default.createElement("img", { src: _etapes2.default })
              ),
              _react2.default.createElement(
                "div",
                { className: "xs-10 sm-11" },
                _react2.default.createElement(
                  "span",
                  null,
                  " ",
                  _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.step_three" }),
                  " "
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: "xs-12" },
              _react2.default.createElement(
                "div",
                { className: "xs-2 sm-1" },
                _react2.default.createElement("img", { src: _etapes2.default })
              ),
              _react2.default.createElement(
                "div",
                { className: "xs-10 sm-11" },
                _react2.default.createElement(
                  "span",
                  null,
                  " ",
                  _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.step_four" }),
                  " "
                )
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "div",
                { className: "xs-2 sm-1" },
                _react2.default.createElement("img", { src: _etapes2.default })
              ),
              _react2.default.createElement(
                "div",
                { className: "xs-10 sm-11" },
                _react2.default.createElement(
                  "span",
                  null,
                  " ",
                  _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.step_five" }),
                  " "
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "xs-12 top" },
          _react2.default.createElement(
            "h3",
            null,
            " Livrables "
          ),
          _react2.default.createElement(
            "ul",
            { id: "livrables" },
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement("img", { src: _check2.default }),
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.one.deliverable_one" })
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement("img", { src: _check2.default }),
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.deliverable_two" })
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement("img", { src: _check2.default }),
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.deliverable_three" })
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement("img", { src: _check2.default }),
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.deliverable_four" })
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement("img", { src: _check2.default }),
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.deliverable_five" })
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement("img", { src: _check2.default }),
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.deliverable_six" })
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement("img", { src: _check2.default }),
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.deliverable_seven" })
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement("img", { src: _check2.default }),
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: "services.two.deliverable_eight" })
              )
            )
          )
        )
      )
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 785:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjAwMDEgMi42NjY2OUM4LjY0MDA4IDIuNjY2NjkgMi42NjY3NSA4LjY0MDAyIDIuNjY2NzUgMTZDMi42NjY3NSAyMy4zNiA4LjY0MDA4IDI5LjMzMzQgMTYuMDAwMSAyOS4zMzM0QzIzLjM2MDEgMjkuMzMzNCAyOS4zMzM0IDIzLjM2IDI5LjMzMzQgMTZDMjkuMzMzNCA4LjY0MDAyIDIzLjM2MDEgMi42NjY2OSAxNi4wMDAxIDIuNjY2NjlaTTE2LjAwMDEgMjYuNjY2N0MxMC4xMjAxIDI2LjY2NjcgNS4zMzM0MSAyMS44OCA1LjMzMzQxIDE2QzUuMzMzNDEgMTAuMTIgMTAuMTIwMSA1LjMzMzM1IDE2LjAwMDEgNS4zMzMzNUMyMS44ODAxIDUuMzMzMzUgMjYuNjY2NyAxMC4xMiAyNi42NjY3IDE2QzI2LjY2NjcgMjEuODggMjEuODgwMSAyNi42NjY3IDE2LjAwMDEgMjYuNjY2N1oiIGZpbGw9IiNBQ0JCMTUiLz4KPHBhdGggZD0iTTIyLjEyIDEwLjEwNjdMMTMuMzMzMyAxOC44OTM0TDkuODggMTUuNDUzNEw4IDE3LjMzMzRMMTMuMzMzMyAyMi42NjY3TDI0IDEyTDIyLjEyIDEwLjEwNjdaIiBmaWxsPSIjQUNCQjE1Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ 786:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNBQ0JCMTUiLz4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iOCIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/p_two.6388190e.png";

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Services/b.a425978f.js